import { AuthConfig } from '@lockton-apps/shared/interfaces';

import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = {
  apiUrls: [environment.apiUrl, environment.apiUrlV2],
  redirectUrl: '/sign-in',
};
